import { isInboundIntervenePayload } from '../../utils/interveneMessageSound';
import {
  findOptimisticOutboundIndex,
  isDuplicateInterveneMessage,
  mergeIncomingWithOptimistic,
} from '../../utils/messageDedup';
import { playMessageSound } from '../../../../shared/notifications';

function hasDuplicateMessage(messages, incoming) {
  return (messages || []).some((message) =>
    isDuplicateInterveneMessage(message, incoming)
  );
}

function normalizeBotMatch(currentBot, incomingBot) {
  if (!currentBot || !incomingBot) return true;
  const cleanCurrent = `${currentBot}`.replace(/\D/g, '');
  const cleanIncoming = `${incomingBot}`.replace(/\D/g, '');
  if (!cleanCurrent || !cleanIncoming) return true;
  return (
    cleanCurrent === cleanIncoming ||
    (cleanCurrent.length >= 10 &&
      cleanIncoming.length >= 10 &&
      cleanCurrent.slice(-10) === cleanIncoming.slice(-10))
  );
}

export function createHandleChatMessage({
  getActiveUser,
  botNumber,
  setMessageList,
}) {
  return (incomingMessage) => {
    if (!incomingMessage) return;

    const activeUser = typeof getActiveUser === 'function' ? getActiveUser() : null;

    const activePhone = activeUser?.phone_number;
    const incomingPhone =
      incomingMessage?.phone_number ||
      incomingMessage?.phone ||
      incomingMessage?.user_phone ||
      incomingMessage?.destination_number ||
      incomingMessage?.to ||
      incomingMessage?.message?.phone_number ||
      incomingMessage?.message_data?.phone_number;

    const incomingBot =
      incomingMessage?.bot_number ||
      incomingMessage?.botNumber ||
      incomingMessage?.channel_number ||
      incomingMessage?.message?.bot_number ||
      incomingMessage?.message_data?.bot_number;

    if (!activePhone || !incomingPhone) {
      return;
    }

    const cleanActive = `${activePhone}`.replace(/\D/g, '');
    const cleanIncoming = `${incomingPhone}`.replace(/\D/g, '');

    const phoneMatches =
      cleanActive === cleanIncoming ||
      (cleanActive.length >= 10 &&
        cleanIncoming.length >= 10 &&
        cleanActive.slice(-10) === cleanIncoming.slice(-10));

    if (!phoneMatches) {
      return;
    }

    const currentBot =
      typeof botNumber === 'function'
        ? botNumber()
        : botNumber || activeUser?.bot_number;

    if (currentBot && incomingBot && !normalizeBotMatch(currentBot, incomingBot)) {
      return;
    }

    const rawIncoming =
      incomingMessage.message && typeof incomingMessage.message === 'object'
        ? { ...incomingMessage.message, ...incomingMessage }
        : incomingMessage.message_data && typeof incomingMessage.message_data === 'object'
          ? { ...incomingMessage.message_data, ...incomingMessage }
          : incomingMessage;

    const rawOrigin = `${rawIncoming.origin || ''}`.toUpperCase();
    const isExplicitInbound = rawOrigin === 'INBOUND';
    const isExplicitOutbound = rawOrigin === 'OUTBOUND';

    const isOutbound =
      isExplicitOutbound ||
      (!isExplicitInbound &&
        (rawIncoming.chat_type === 'human_agent' ||
          Boolean(rawIncoming.intervened_by)));

    const messageToStore = {
      ...rawIncoming,
      origin: isOutbound ? 'OUTBOUND' : 'INBOUND',
      phone_number: rawIncoming.phone_number || incomingPhone,
      bot_number: rawIncoming.bot_number || incomingBot || currentBot || '',
    };

    const shouldPlayActiveChatSound = isInboundIntervenePayload(messageToStore);

    setMessageList((prev) => {
      const messages = prev?.messages || [];

      const optimisticIndex = findOptimisticOutboundIndex(
        messages,
        messageToStore
      );

      if (optimisticIndex >= 0) {
        const nextMessages = [...messages];

        nextMessages[optimisticIndex] = mergeIncomingWithOptimistic(
          messages[optimisticIndex],
          messageToStore
        );

        return {
          ...prev,
          messages: nextMessages,
        };
      }

      if (hasDuplicateMessage(messages, messageToStore)) {
        return prev;
      }

      return {
        ...prev,
        messages: [...messages, messageToStore],
        total_count: (prev?.total_count || 0) + 1,
      };
    });

    if (shouldPlayActiveChatSound) {
      playMessageSound('activeChat');
    }
  };
}
